export function useCsrfToken(): string {
    const isServer = typeof window === 'undefined';

    return isServer
        ? ''
        : document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute('content') ?? '';
}
